<fr-table [config]="serverFileSelectTableConfig" [data]="files" Id="server-file-table"
  [paginatorConfig]="paginatorConfig">
  <div class="table-sub-header" above-table-body-space>
    <mat-spinner *ngIf="loadInProgress" [diameter]="30"></mat-spinner>
  </div>
</fr-table>